"use client";

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function AIUserUsageTable() {
  const { data: userStats, isLoading } = useQuery({
    queryKey: ['ai-user-usage'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('ai_user_usage_stats')
        .select(`
          *,
          profiles!ai_user_usage_stats_user_id_fkey(user_id),
          organizations(name)
        `)
        .order('lifetime_cost_cents', { ascending: false });
      
      if (error) throw error;
      
      return data;
    },
  });

  return (
    <Card>
      <CardContent className="pt-6">
        {isLoading ? (
          <div className="text-center py-8 text-muted-foreground">Loading user statistics...</div>
        ) : !userStats?.length ? (
          <div className="text-center py-8 text-muted-foreground">
            No user data available yet. Data will appear when users interact with the AI Specification Assistant.
          </div>
        ) : (
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>User</TableHead>
                  <TableHead>Organization</TableHead>
                  <TableHead className="text-right">Conversations</TableHead>
                  <TableHead className="text-right">Total Tokens</TableHead>
                  <TableHead className="text-right">Cache Efficiency</TableHead>
                  <TableHead className="text-right">Lifetime Cost</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {userStats.map((stat) => (
                  <TableRow key={stat.user_id}>
                    <TableCell className="font-medium">
                      {stat.user_id}
                    </TableCell>
                    <TableCell>{(stat.organizations as any)?.name || 'Unknown'}</TableCell>
                    <TableCell className="text-right">{stat.total_conversations}</TableCell>
                    <TableCell className="text-right">
                      {((stat.lifetime_input_tokens || 0) + (stat.lifetime_output_tokens || 0)).toLocaleString()}
                    </TableCell>
                    <TableCell className="text-right">
                      {stat.cache_efficiency_percent?.toFixed(1)}%
                    </TableCell>
                    <TableCell className="text-right">
                      ${((stat.lifetime_cost_cents || 0) / 100).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
